import { cn } from '../../../../utils';
import { ContentDescription } from '../shared/content-description';
import type { ContentDisplayVariant } from '../../hooks/content-renderer-types';
import type { StudentAudioContent } from '../../hooks/use-class-blocks';
import { renderInlineMarkdown } from '../../../custom/markdown';

interface AudioContentDisplayProps {
  content: StudentAudioContent;
  variant?: ContentDisplayVariant;
}

export function AudioContentDisplay({ content, variant = 'card' }: AudioContentDisplayProps) {
  if (!content.url) {
    return null;
  }

  return (
    <div className={cn('space-y-2', variant === 'inline' && 'text-left')}>
      {content.title && (
        <h3 className="text-lg font-semibold">
          {renderInlineMarkdown(content.title, 'audio-content-title')}
        </h3>
      )}
      <audio controls className="w-full">
        <source src={content.url} />
        Your browser does not support the audio element.
      </audio>
      <ContentDescription text={content.description} markdown />
    </div>
  );
}
